import { NocStatus } from "@/nocComponents/hooks/useNocData";
import { NOC_STEP_NOT_STARTED } from "@/nocComponents/Noc/Noc.constants";
import {
  buyerDocumentsUploadInitialFormState,
  sellerDocumentsUploadInitialFormState,
} from "@/nocComponents/ownersAssociationNOC/SellerDocumentsUpload/constants";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeStep: 0,
  serviceChargesData: {},
  activityNotification: {
    show: false,
    title: "",
    description: "",
  },
  nocDetails: {
    developerNoc: { overallStatus: "", tasksStatus: [] },
    tasks: [],
  },
  unitDetails: {
    unitId: "",
    unitName: "",
    imageUrl:"",
    communityName: "",
    communityId: "",
    salesOrderId: "",
  },
  buyerSignDocStatus: {
    ownerAssociationNoc: false,
    DoaDocument: false,
  },
  nocPaymentJourney: {},
  sellerDocumentsUploadFormState: sellerDocumentsUploadInitialFormState,
  buyerDocumentsUploadFormState: buyerDocumentsUploadInitialFormState,
  devNocAccordion: false,
  toastNotification: {
    show: false,
    message: "",
  },
  isProgressUpdating: false,
  OwnerNocTitleSet: false,
  DoaDocumentTitleSet: false,
  expiredDocs:{
    passport:false,
    emiratesIdFront:false,
    emiratesIdBack:false
  },
  coOwnerLoading: false,
  coOwnerData: null
};

const nocJourneySlice = createSlice({
  name: "nocJourneySlice",
  initialState: initialState,
  reducers: {
    setCurrentNocJourney: (state, action): any => {
      return action.payload;
    },
    updateCurrentNocJourney: (state, action): any => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetNocJourney: (state): any => {
      return { ...initialState };
    },
    setServiceChargesData: (state: any, action) => {
      state.serviceChargesData = action.payload;
    },
    showActivityNotification: (state: any, action) => {
      state.activityNotification = {
        show: true,
        title: action.payload.title,
        description: action.payload.description,
        isDevNocPayment: action.payload?.isDevNocPayment ?? false,
      };
    },
    hideActivityNotification: (state: any) => {
      state.activityNotification.show = false;
    },
    handleProceedNextStep: (state: any): any => {
      const { nocDetails, activeStep } = state;

      //current active step status
      let currentActiveStepStatus: NocStatus = nocDetails?.overallStatus;

      // /**
      //  * When the current step is complete the isCompleted field in noc details is marked as done
      //  * but there is a step where process in not started at that phase isCompleted should remain same (currentActiveStepStatus !== NOC_STEP_NOT_STARTED) is for that
      //  */
      const updatedProcessState = nocDetails?.tasks?.map(
        (
          item: { idx: number; desc: string; isCompleted: Boolean },
          index: number
        ) =>
          index === activeStep &&
          currentActiveStepStatus !== NOC_STEP_NOT_STARTED
            ? { ...item, isCompleted: true }
            : item
      );

      let newPayload;
      newPayload = {
        activeStep: activeStep + 1,
        nocDetails: {
          ...nocDetails,
          tasks: updatedProcessState,
        },
      };
      return {
        ...state,
        ...newPayload,
      };
    },
    updateNocPaymentJourney: (state, action) => {
      state.nocPaymentJourney = action.payload;
    },
    resetNocPaymentJourney: (state) => {
      return { ...state, nocPaymentJourney: {} };
    },
    resetSellerDocUploadForm: (state) => {
      state.sellerDocumentsUploadFormState =
        sellerDocumentsUploadInitialFormState;
    },
    setSellerDocUploadFormValues: (state: any, action) => {
      if (action.payload.isFile) {
        state.sellerDocumentsUploadFormState.values[action.payload.fieldName] =
          {
            ...(state.sellerDocumentsUploadFormState.values[
              action.payload.fieldName
            ] || {}),
            ...(action.payload?.fieldValue || {}),
          };
      } else {
        state.sellerDocumentsUploadFormState.values[action.payload.fieldName] =
          action.payload?.fieldValue;
      }
    },
    setSellerDocUploadFormLoading: (state: any, action) => {
      state.sellerDocumentsUploadFormState.loading[action.payload.fieldName] =
        action.payload.fieldValue;
    },
    setSellerDocUploadFormErrors: (state: any, action) => {
      state.sellerDocumentsUploadFormState.errors[action.payload.fieldName] =
        action.payload.fieldValue;
    },
    updateSellerDocsDocuSignStatus: (state: any, action) => {
      state.sellerDocumentsUploadFormState.docuSignStatus[
        action.payload.fieldName
      ] = action.payload;
    },
    showToastMessage: (state: any, action) => {
      state.toastNotification = {
        show: true,
        message: action.payload.message,
      };
    },
    hideToastMessage: (state) => {
      state.toastNotification = {
        show: false,
        message: "",
      };
    },
    setProgressUpdating: (state, action) => {
      state.isProgressUpdating = action.payload;
    },
    setUnitDetails: (state: any, action) => {
      state.unitDetails = action.payload;
    },
    setBuyerDocUploadFormValues: (state: any, action) => {
      if (action.payload.isFile) {
        state.buyerDocumentsUploadFormState.values[action.payload.fieldName] =
          {
            ...(state.buyerDocumentsUploadFormState.values[
              action.payload.fieldName
            ] || {}),
            ...(action.payload?.fieldValue || {}),
          };
      } else {
        state.buyerDocumentsUploadFormState.values[action.payload.fieldName] =
          action.payload?.fieldValue;
      }
    },
    setBuyerDocUploadFormLoading: (state: any, action) => {
      state.buyerDocumentsUploadFormState.loading[action.payload.fieldName] =
        action.payload.fieldValue;
    },
    setBuyerDocUploadFormErrors: (state: any, action) => {
      state.buyerDocumentsUploadFormState.errors[action.payload.fieldName] =
        action.payload.fieldValue;
    },
    clearBuyerDocUploadFile: (state: any, action) => {
      const { fieldName } = action.payload;
          if (state.buyerDocumentsUploadFormState.values[fieldName]) {
        state.buyerDocumentsUploadFormState.values[fieldName] = {
          fileName: "",
          downloadUrl: "",
        };
      }
    },
    setExpiredDocsStatus: (state: any, action) => {
      const { fieldName } = action.payload;
        state.expiredDocs = {
          ...state.expiredDocs,
          [fieldName]: false,
        };
    },
    setBuyerExpiredDocStatus: (state: any, action) => {
      state.expiredDocs = action.payload;
    },
    setCoOwnerLoading: (state, action) => {
      state.coOwnerLoading = action.payload;
    },
    setCoOwnerData: (state, action) => {
      state.coOwnerData = action.payload;
    },
  },
});

export const {
  setCurrentNocJourney,
  updateCurrentNocJourney,
  resetNocJourney,
  setServiceChargesData,
  showActivityNotification,
  hideActivityNotification,
  handleProceedNextStep,
  updateNocPaymentJourney,
  resetNocPaymentJourney,
  resetSellerDocUploadForm,
  setSellerDocUploadFormValues,
  setSellerDocUploadFormLoading,
  setSellerDocUploadFormErrors,
  updateSellerDocsDocuSignStatus,
  showToastMessage,
  hideToastMessage,
  setProgressUpdating,
  setUnitDetails,
  setBuyerDocUploadFormValues,
  setBuyerDocUploadFormLoading,
  setBuyerDocUploadFormErrors,
  clearBuyerDocUploadFile,
  setExpiredDocsStatus,
  setBuyerExpiredDocStatus,
  setCoOwnerLoading,
  setCoOwnerData
} = nocJourneySlice.actions;

export default nocJourneySlice.reducer;
